import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../login/AuthProvider";
import { switchHelper, dateHelper, dictFinder } from "../../modules/helpers";
import { qa, qa_search, teacher } from "../../components/apipath";
import HTMLEditor from "../../components/htmleditor";

let htmlContent = "";

function Admqa() {
    const { token, id, type } = useAuth();
    const today = dateHelper(Date.now(), "date");
    const yearStart = `${new Date().getFullYear()}-01-01`;
    const [searchForm, setSearchForm] = useState({
        startDate: yearStart,
        endDate: today,
        user_type: null,
        teacher_id: null,
        chinese_name: null,
        reply_status: null,
        subject: null,
        xtype: null,
        chapter: null,
    });
    const [rowsCount, setRowsCount] = useState();
    const [startSearch, setStartSearch] = useState(false);
    const [teacherList, setTeacherList] = useState();
    const [qaData, setQaData] = useState([]);
    const [editingQA, setEditingQA] = useState(null);
    const [updatedData, setUpdatedData] = useState({});

    const userTypeList = ["CPA", "CMA"];
    const replyStatusList = ["請選擇", "尚未回覆", "已回覆", "不予回答"];
    const subjectList = ["請選擇", "aud", "bar", "bec", "far", "reg", "tcp", "isc"];
    const xtypeList = ["請選擇", "mcq", "moc", "sim"];
    const chapterList = [
        "請選擇",
        "A1",
        "A2",
        "A3",
        "A4",
        "A5",
        "A6",
        "B1",
        "B2",
        "B3",
        "B4",
        "B5",
        "B6",
        "F1",
        "F2",
        "F3",
        "F4",
        "F5",
        "F6",
        "F7",
        "F8",
        "F9",
        "F10",
        "R1",
        "R2",
        "R3",
        "R4",
        "R5",
        "R6",
        "R7",
        "R8",
    ];
    // const sim_setList = ['請選擇', 'SIM1', 'SIM2'];
    // const moc_setList = ['請選擇', 'exam1', 'exam2'];
    // const testletList = ['請選擇', 'testlet1', 'testlet2', 'testlet3', 'testlet4', 'testlet5'];

    const replyStatusMap = {
        0: "尚未回覆",
        1: "已回覆",
        2: "不予回答",
    };

    useEffect(() => {
        const initQA = async () => {
            try {
                if (!type) return;

                if (type === "admin") {
                    const response = await axios.get(`${qa}lastdata`, { headers: { token } });
                    setQaData(response.data[0]);
                    setRowsCount(response.data[1][0]?.total || 0);
                } else if (type === "teacher") {
                    const initForm = {
                        startDate: yearStart,
                        endDate: today,
                        user_type: null,
                        teacher_id: null,
                        chinese_name: null,
                        reply_status: null,
                        subject: null,
                        xtype: null,
                        chapter: null,
                    };

                    setSearchForm(initForm);
                    await fetchQAData(1, 50, initForm);
                }
            } catch (err) {
                console.error("取得 QA 錯誤：", err);
            }
        };

        initQA();
    }, [token, type]);

    // useEffect(() => {
    //     const fetchLatestQA = async () => {
    //     try {
    //         const response = await axios.get(`${qa}lastdata`, { headers: { token } });
    //         setQaData(response.data[0]);
    //         setRowsCount(response.data[1][0]?.total || 0);
    //     } catch (err) {
    //         console.error("取得最新 QA 錯誤：", err);
    //     }
    //     };
    //     fetchLatestQA();
    // }, [token]);

    useEffect(() => {
        fetchTeacherData(id, type);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchQAData = async (page = 1, rows = 50, form = searchForm) => {
        try {
            if (page - 1 <= 0) page = 1;

            const response = await axios.post(`${qa_search(page - 1, rows)}`, form, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    token: token,
                },
            });

            setQaData(response.data[0]?.data || []);
            setRowsCount(response.data[1]?.data?.[0]?.total || 0);
            console.log("Search payload:", form);
            console.log("Search response:", response.data);
        } catch (error) {
            console.error("Error:", error);
        }
    };
    const fetchTeacherData = async (id, type) => {
        try {
        const response = await axios.get(`${teacher}${type === "teacher" ? id : ""}`, {
            headers: { token },
        });

        const result = Array.isArray(response.data) ? response.data : [response.data];
        setTeacherList(result);
        console.log(result);
        } catch (error) {
        console.error("Error:", error);
        }
    };

    const startEditing = (qaItem) => {
        setEditingQA(qaItem);
        setUpdatedData({
        ...qaItem,
        qa_id: qaItem.qa_id,
        reply_status: qaItem.reply_status ?? 0, // 0: 尚未回覆, 1: 已回覆, 2: 不予回答
        });
        htmlContent = qaItem.reply || "";
    };

    const handleSearch = () => {
        fetchQAData();
        setStartSearch(true);
    };

    const handleSearchFormChange = (e) => {
        const { name, value } = e.target;
        setSearchForm({
        ...searchForm,
        [name]: value === "" ? null : value,
        });
    };

    const handleInputChange = (e) => {
        const { name, value, checked, type: inputType } = e.target;

        if (inputType === "checkbox") {
        setUpdatedData((prev) => ({
            qa_id: editingQA.qa_id,
            ...prev,
            [name]: switchHelper(checked),
        }));
        } else if (name === "teacher_id") {
        setUpdatedData((prev) => ({
            qa_id: editingQA.qa_id,
            ...prev,
            [name]: value,
            teacher: dictFinder(teacherList, "teacher_id", value)?.name,
        }));
        } else if (name === "reply_status") {
        setUpdatedData((prev) => ({
            qa_id: editingQA.qa_id,
            ...prev,
            reply_status: Number(value), // 重要：轉數字
        }));
        } else {
        setUpdatedData((prev) => ({
            qa_id: editingQA.qa_id,
            ...prev,
            [name]: value,
        }));
        }
    };

    const handleHTMLEditorChange = (name, contents) => {
        htmlContent = contents;

        // 可選：若輸入了內容，且目前不是「不予回答」，自動切為「已回覆」
        setUpdatedData((prev) => {
        const text = (contents || "").replace(/<[^>]+>/g, "").trim();
        if ((prev?.reply_status ?? 0) !== 2 && text) {
            return { ...prev, reply_status: 1 };
        }
        return prev;
        });
    };

    // Update：將資訊回傳給後端（包含 reply_status 與 reply）
    const saveChanges = async () => {
        try {
        const payload = {
            ...editingQA, // 先帶入原資料避免漏欄位
            ...updatedData, // 覆蓋成最新編輯值
            reply: htmlContent, // 富文字回覆
            qa_id: editingQA.qa_id,
        };

        await axios.put(`${qa}`, payload, {
            headers: {
            Authorization: `Bearer ${token}`,
            token: token,
            },
        });

        // 更新前端列表
        const updatedQAList = qaData.map((item) =>
            item.qa_id === editingQA.qa_id ? { ...item, ...payload } : item
        );
        setQaData(updatedQAList);

        // 收尾
        htmlContent = "";
        setEditingQA(null);
        } catch (error) {
        console.error("Error updating qa:", error);
        }
    };

    return (
        <>
        <div className="mt100 container">
            <div className="row g-2 mb-5">
            {searchForm && (
                <>
                <div className="col-xl-2 col-md-3 col-4">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">起始日期</span>
                    <input
                        className="form-control form-control-sm"
                        type="date"
                        name="startDate"
                        value={searchForm.startDate || ""}
                        onChange={handleSearchFormChange}
                        max={dateHelper(Date.now(), "date")}
                        min={dateHelper("2020-01-01", "date")}
                    />
                    </div>
                </div>
                <div className="col-xl-2 col-md-3 col-4">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">結束日期</span>
                    <input
                        className="form-control form-control-sm"
                        type="date"
                        name="endDate"
                        value={searchForm.endDate || ""}
                        onChange={handleSearchFormChange}
                        max={dateHelper(Date.now(), "date")}
                        min={dateHelper("2020-01-01", "date")}
                    />
                    </div>
                </div>
                <div className="col-xl-2 col-md-3 col-4">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">科目</span>
                    <select
                        className="form-select form-select-sm"
                        name="user_type"
                        onChange={handleSearchFormChange}
                        defaultValue={searchForm.user_type}
                        required
                    >
                        {userTypeList.map((item) => (
                        <option key={item} value={item}>
                            {item}
                        </option>
                        ))}
                    </select>
                    </div>
                </div>
                <div className="col-xl-2 col-md-3 col-4">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">主題</span>
                    <select
                        className="form-select form-select-sm"
                        name="subject"
                        onChange={handleSearchFormChange}
                        defaultValue={searchForm.subject}
                        required
                    >
                        {subjectList.map((item, index) => (
                        <option key={index} value={index === 0 ? "" : item}>
                            {item}
                        </option>
                        ))}
                    </select>
                    </div>
                </div>
                <div className="col-xl-2 col-md-3 col-4">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">類別</span>
                    <select
                        className="form-select form-select-sm"
                        name="xtype"
                        onChange={handleSearchFormChange}
                        defaultValue={searchForm.xtype}
                        required
                    >
                        {xtypeList.map((item, index) => (
                        <option key={index} value={index === 0 ? "" : item}>
                            {item}
                        </option>
                        ))}
                    </select>
                    </div>
                </div>
                <div className="col-xl-2 col-md-3 col-4">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">章節</span>
                    <select
                        className="form-select form-select-sm"
                        name="chapter"
                        onChange={handleSearchFormChange}
                        defaultValue={searchForm.chapter}
                        required
                    >
                        {chapterList.map((item, index) => (
                        <option key={index} value={index === 0 ? "" : item}>
                            {item}
                        </option>
                        ))}
                    </select>
                    </div>
                </div>
                <div className="col-xl-2 col-md-3 col-4">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">學生姓名</span>
                    <input
                        className="form-control form-control-sm"
                        name="chinese_name"
                        defaultValue={searchForm.chinese_name}
                        onChange={handleSearchFormChange}
                    />
                    </div>
                </div>
                <div className="col-xl-2 col-md-3 col-4">
                    <div className="input-group input-group-sm">
                    <span className="input-group-text">回覆狀態</span>
                    <select
                        className="form-select form-select-sm"
                        name="reply_status"
                        defaultValue={searchForm.reply_status}
                        onChange={handleSearchFormChange}
                    >
                        {replyStatusList.map((item, index) => (
                        <option key={index} value={index === 0 ? "" : index - 1}>
                            {item}
                        </option>
                        ))}
                    </select>
                    </div>
                </div>
                <div className="col-xl-8 col-md-12 col-4 text-end">
                    <button className="btn btn-sm btn-primary" onClick={handleSearch}>
                    搜尋
                    </button>
                </div>
                </>
            )}
            </div>

            <div className="mt-2 table-responsive">
            <table className="table table-striped border table-hover">
                <thead>
                <tr className="text-center">
                    <th>編號</th>
                    <th>學生</th>
                    <th>發問次數</th>
                    <th>題目</th>
                    <th>老師</th>
                    <th>狀態</th>
                    <th>發問日期</th>
                    <th>編輯</th>
                </tr>
                </thead>
                {Array.isArray(qaData) &&
                    qaData.map((qaItem) => (
                    <tbody key={qaItem.qa_id}>
                        {editingQA && editingQA.qa_id === qaItem.qa_id ? (
                        <tr>
                            <th colSpan={8}>
                            <div className="row g-2">
                                <div className="text-end">
                                <button className="btn btn-primary m-1" onClick={saveChanges}>
                                    保存
                                </button>
                                <button
                                    className="btn btn-secondary m-1"
                                    onClick={() => {
                                    setEditingQA(null);
                                    htmlContent = "";
                                    }}
                                >
                                    取消
                                </button>
                                </div>

                                <div className="col-3">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">學生</span>
                                    <input
                                    className="form-control form-control-sm"
                                    type="text"
                                    value={qaItem.chinese_name}
                                    readOnly
                                    />
                                </div>
                                </div>
                                <div className="col-3">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">主題</span>
                                    <input
                                    className="form-control form-control-sm"
                                    type="text"
                                    value={qaItem.subject}
                                    readOnly
                                    />
                                </div>
                                </div>
                                <div className="col-3">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">分類</span>
                                    <input
                                    className="form-control form-control-sm"
                                    type="text"
                                    value={qaItem.xtype}
                                    readOnly
                                    />
                                </div>
                                </div>
                                <div className="col-3">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">題號</span>
                                    <input
                                    className="form-control form-control-sm"
                                    type="text"
                                    value={qaItem.cpa}
                                    readOnly
                                    />
                                </div>
                                </div>

                                <div className="col-3">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">老師</span>
                                    <select
                                    name="teacher_id"
                                    className="form-select form-select-sm"
                                    value={
                                        (updatedData && updatedData.teacher_id) ??
                                        qaItem.teacher_id ??
                                        ""
                                    }
                                    onChange={handleInputChange}
                                    required
                                    >
                                    {Array.isArray(teacherList) &&
                                        teacherList.map((t) => (
                                        <option key={t.teacher_id} value={t.teacher_id}>
                                            {t.name}
                                        </option>
                                        ))}
                                    </select>
                                </div>
                                </div>

                                {/* 新增：狀態 */}
                                <div className="col-3">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">狀態</span>
                                    <select
                                    name="reply_status"
                                    className="form-select form-select-sm"
                                    value={
                                        (updatedData && updatedData.reply_status) ??
                                        qaItem.reply_status ??
                                        0
                                    }
                                    onChange={handleInputChange}
                                    required
                                    >
                                    <option value={0}>尚未回覆</option>
                                    <option value={1}>已回覆</option>
                                    <option value={2}>不予回答</option>
                                    </select>
                                </div>
                                </div>

                                <div className="col-12">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">學生問題</span>
                                    <textarea
                                    rows={10}
                                    className="form-control form-control-sm"
                                    value={qaItem.my_question}
                                    readOnly
                                    />
                                </div>
                                </div>
                                <div className="col-12">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">學生答案</span>
                                    <textarea
                                    rows={10}
                                    className="form-control form-control-sm"
                                    value={qaItem.my_answer}
                                    readOnly
                                    />
                                </div>
                                </div>
                            </div>

                            <div className="mt-2">
                                <span className="input-group-text">老師回答</span>
                                {HTMLEditor(qaItem.reply, "reply", handleHTMLEditorChange)}
                            </div>
                            </th>
                        </tr>
                        ) : (
                        <tr>
                            <th className="text-center">{qaItem.qa_id}</th>
                            <th className="text-center">{qaItem.chinese_name}</th>
                            <th className="text-center">{qaItem.total}</th>
                            <th className="text-center">
                            科目：{qaItem.subject}
                            <br />
                            題型：{qaItem.xtype}
                            <br />
                            題號：CPA-{qaItem.cpa}
                            </th>
                            <th className="text-center">
                            {qaItem.teacher || "－"}
                            </th>
                            <th className="text-center text-danger">
                            {replyStatusMap[qaItem.reply_status] || "－"}
                            </th>
                            <th className="text-center">
                            {dateHelper(qaItem.create_date, "datetime")}
                            </th>
                            <th className="text-center">
                            <div>
                                <button
                                className="btn btn-sm btn-primary m-2"
                                onClick={() => startEditing(qaItem)}
                                >
                                編輯
                                </button>
                            </div>
                            </th>
                        </tr>
                        )}
                    </tbody>
                    ))}
            </table>
            </div>

            {/* <div className="m-2 p-2">
            { PageList(rowsCount, fetchQAData) }
            </div> */}
        </div>
        </>
    );
}

export default Admqa;
